import { Injectable } from '@angular/core';

import { AppStateLoaderService } from './app-state-loader.service';

@Injectable({providedIn: 'root'})
export class AppStateDataGuard {
  constructor(private readonly dataLoader: AppStateLoaderService) {
  }

  canActivate(): Promise<boolean> {
    return this.dataLoader.loaded();
  }

  canActivateChild() {
    return this.canActivate();
  }
}
